import React, { createContext, useContext } from 'react';
export const SandboxContext = createContext(null);
export const SandboxContextProvider = (props) => React.createElement(SandboxContext.Provider, { value: props.sandbox }, props.children);
export const SandboxConsumer = SandboxContext.Consumer;
export const useSandboxContext = () => useContext(SandboxContext);
//# sourceMappingURL=SandboxContext.js.map